// @ts-ignore
import './app.css';

import { store } from './store';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { App } from './app';

createRoot(document.getElementById('root')!).render(
    <Provider store={store}>
        {/*<StrictMode>*/}
        <App />
        {/*</StrictMode>*/}
    </Provider>,
);
